export default __webpack_public_path__ + "static/media/centro_odontologico_caballito.bbd27943.jpg";